import { Country } from '../types/api';

const ALPHA3_TO_ALPHA2: Record<string, string> = {
  AFG: 'af', ALB: 'al', ALG: 'dz', AND: 'ad', ANG: 'ao', ANT: 'ag', ARG: 'ar',
  ARM: 'am', ARU: 'aw', ASA: 'as', AUS: 'au', AUT: 'at', AZE: 'az', BAH: 'bs',
  BAN: 'bd', BAR: 'bb', BDI: 'bi', BEL: 'be', BEN: 'bj', BER: 'bm', BHU: 'bt',
  BIH: 'ba', BIZ: 'bz', BLR: 'by', BOL: 'bo', BOT: 'bw', BRA: 'br', BRN: 'bh',
  BRU: 'bn', BUL: 'bg', BUR: 'bf', CAF: 'cf', CAM: 'kh', CAN: 'ca', CAY: 'ky',
  CGO: 'cg', CHA: 'td', CHI: 'cl', CHN: 'cn', CIV: 'ci', CMR: 'cm', COD: 'cd',
  COK: 'ck', COL: 'co', COM: 'km', CPV: 'cv', CRC: 'cr', CRO: 'hr', CUB: 'cu',
  CYP: 'cy', CZE: 'cz', DEN: 'dk', DJI: 'dj', DMA: 'dm', DOM: 'do', ECU: 'ec',
  EGY: 'eg', ERI: 'er', ESA: 'sv', ESP: 'es', EST: 'ee', ETH: 'et', FIJ: 'fj',
  FIN: 'fi', FRA: 'fr', FSM: 'fm', GAB: 'ga', GAM: 'gm', GBR: 'gb', GBS: 'gw',
  GEO: 'ge', GEQ: 'gq', GER: 'de', GHA: 'gh', GRE: 'gr', GRN: 'gd', GUA: 'gt',
  GUI: 'gn', GUM: 'gu', GUY: 'gy', HAI: 'ht', HKG: 'hk', HON: 'hn', HUN: 'hu',
  INA: 'id', IND: 'in', IRI: 'ir', IRL: 'ie', IRQ: 'iq', ISL: 'is', ISR: 'il',
  ISV: 'vi', ITA: 'it', IVB: 'vg', JAM: 'jm', JOR: 'jo', JPN: 'jp', KAZ: 'kz',
  KEN: 'ke', KGZ: 'kg', KIR: 'ki', KOR: 'kr', KOS: 'xk', KSA: 'sa', KUW: 'kw',
  LAO: 'la', LAT: 'lv', LBA: 'ly', LBN: 'lb', LBR: 'lr', LCA: 'lc', LES: 'ls',
  LIE: 'li', LTU: 'lt', LUX: 'lu', MAD: 'mg', MAR: 'ma', MAS: 'my', MAW: 'mw',
  MDA: 'md', MDV: 'mv', MEX: 'mx', MGL: 'mn', MKD: 'mk', MLI: 'ml', MLT: 'mt',
  MNE: 'me', MON: 'mc', MOZ: 'mz', MRI: 'mu', MTN: 'mr', MYA: 'mm', NAM: 'na',
  NCA: 'ni', NED: 'nl', NEP: 'np', NGR: 'ng', NIG: 'ne', NOR: 'no', NRU: 'nr',
  NZL: 'nz', OMA: 'om', PAK: 'pk', PAN: 'pa', PAR: 'py', PER: 'pe', PHI: 'ph',
  PLE: 'ps', PLW: 'pw', PNG: 'pg', POL: 'pl', POR: 'pt', PRK: 'kp', PUR: 'pr',
  QAT: 'qa', ROU: 'ro', RSA: 'za', RUS: 'ru', RWA: 'rw', SAM: 'ws', SEN: 'sn',
  SEY: 'sc', SIN: 'sg', SKN: 'kn', SLE: 'sl', SLO: 'si', SMR: 'sm', SOL: 'sb',
  SOM: 'so', SRB: 'rs', SRI: 'lk', STP: 'st', SUD: 'sd', SUI: 'ch', SUR: 'sr',
  SVK: 'sk', SWE: 'se', SWZ: 'sz', SYR: 'sy', TAN: 'tz', TGA: 'to', THA: 'th',
  TJK: 'tj', TKM: 'tm', TLS: 'tl', TOG: 'tg', TPE: 'tw', TTO: 'tt', TUN: 'tn',
  TUR: 'tr', TUV: 'tv', UAE: 'ae', UGA: 'ug', UKR: 'ua', URU: 'uy', USA: 'us',
  UZB: 'uz', VAN: 'vu', VEN: 've', VIE: 'vn', VIN: 'vc', YEM: 'ye', ZAM: 'zm',
  ZIM: 'zw',
  // Standard ISO alpha-3 that differ from FEI/IOC codes above
  DEU: 'de', NLD: 'nl', CHE: 'ch', DNK: 'dk', ZAF: 'za',
  GRC: 'gr', HRV: 'hr', IDN: 'id', IRN: 'ir', ARE: 'ae', SAU: 'sa',
  TWN: 'tw', KHM: 'kh', MMR: 'mm', PRY: 'py', VNM: 'vn',
  PRT: 'pt', LVA: 'lv', KWT: 'kw', SVN: 'si', MCO: 'mc', BGR: 'bg',
  DZA: 'dz', CHL: 'cl', GTM: 'gt', LBY: 'ly', OMN: 'om', ZWE: 'zw',
  MYS: 'my', PSE: 'ps', SGP: 'sg', COG: 'cg', CRI: 'cr', URY: 'uy', HND: 'hn',
};

export function alpha3ToAlpha2(alpha3: string): string | null {
  if (!alpha3) return null;
  return ALPHA3_TO_ALPHA2[alpha3.toUpperCase()] ?? null;
}

export function getCircleFlagUrl(alpha3Code: string): string | null {
  const alpha2 = alpha3ToAlpha2(alpha3Code);
  if (!alpha2) return null;
  return `https://hatscripts.github.io/circle-flags/flags/${alpha2}.svg`;
}

export function resolveCountryName(alpha3: string, countries: Country[]): string {
  if (!alpha3) return '';
  const match = countries.find(c => c.code.toUpperCase() === alpha3.toUpperCase());
  return match?.name ?? alpha3;
}

/**
 * Get a flag URL from a value that may be a country name or alpha-3 code.
 * Tries direct alpha-3 lookup first, then reverse-looks up by name in the countries list.
 */
export function getFlagUrlByNameOrCode(countryValue: string, countries: Country[]): string | null {
  if (!countryValue) return null;
  const direct = getCircleFlagUrl(countryValue);
  if (direct) return direct;
  const match = countries.find(c => c.name.toLowerCase() === countryValue.toLowerCase());
  if (match) return getCircleFlagUrl(match.code);
  return null;
}
